import styles from '$components/tabs/tabs-navigation.module.scss';
import type { TabNavigationRoute } from '$components/tabs/tabs.types';

import { Tab } from './tab';

export interface TabProps {
  routes: TabNavigationRoute[];
  isActivePath: (path: string) => boolean;
  handleTabClick: (path: string) => void;
}

export function Tabs({ routes, isActivePath, handleTabClick }: TabProps) {
  return (
    <div role="tablist" className={styles.tabsNavigation}>
      {routes.map((route) => (
        <Tab
          key={route.path}
          route={route}
          isSelected={isActivePath(route.path)}
          onClick={() => handleTabClick(route.path)}
        />
      ))}
    </div>
  );
}
